import { COLOR_ACCENT, COLOR_DARK, COLOR_STROKE, COLOR_WH } from '../colors.constants';

export const colorsRadioAndCheckbox = {
  colorRadioAndCheckboxBackground: COLOR_DARK,
  colorRadioAndCheckboxBorder: COLOR_STROKE,
  colorRadioAndCheckboxBorderHover: COLOR_STROKE,
  colorRadioAndCheckboxChecked: COLOR_ACCENT,
  colorRadioBackgroundChecked: COLOR_WH,
};
